import { DialogActions, DialogContent, FormControl, Grid, TextField } from "@mui/material";
import DialogHESP from "../../DialogHESP/DialogHESP";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../BillingDetails/AddPaymentMethodDialog";
import DialogFooterWithLoading from "../../Loading/DialogFooterWithLoading";
import gql from "graphql-tag";
import { useMutation } from "react-apollo";
import {
    AddCdnSecurityJwtKeyMutation,
    AddCdnSecurityJwtKeyMutationVariables,
} from "./__generated__/AddCdnSecurityJwtKeyMutation";
import HESPFormLabel from "../../HESPFormLabel/HESPFormLabel";
import { useEffect, useState } from "react";
import { v4 } from "uuid";
import { GET_CHANNEL_QUERY } from "../Overview/channelQueriesMutations";

interface Props {
    channelId: string;
    aliasId: string;
    organizationId: string;
    open: boolean;
    onClose: () => void;
}

const ADD_CDN_SECURITY_JWT_KEY_MUTATION = gql`
    mutation AddCdnSecurityJwtKeyMutation($input: AddCdnSecurityJwtKeyInput!) {
        addCdnSecurityJwtKey(input: $input)
    }
`;

export default function AddTokenSecurityKeyDialog({
    aliasId,
    channelId,
    organizationId,
    onClose,
    open,
}: Props): JSX.Element {
    const [keyId, setKeyId] = useState<string>("");
    const [key, setKey] = useState<string>("");

    useEffect(() => {
        setKeyId("");
        setKey("");
    }, [open]);

    const [addKeyMut, { loading }] = useMutation<AddCdnSecurityJwtKeyMutation, AddCdnSecurityJwtKeyMutationVariables>(
        ADD_CDN_SECURITY_JWT_KEY_MUTATION,
    );

    async function addKey(): Promise<void> {
        if (key.trim().length > 0) {
            try {
                await addKeyMut({
                    variables: {
                        input: {
                            aliasId,
                            channelId,
                            organizationId,
                            key: {
                                id: keyId.trim().length === 0 ? v4() : keyId,
                                key,
                            },
                        },
                    },
                    refetchQueries: [
                        {
                            query: GET_CHANNEL_QUERY,
                            variables: {
                                channelId,
                                organizationId,
                            },
                        },
                    ],
                });
                toast.success("Key added", TOAST_SETTINGS);
                onClose();
            } catch (_e) {
                toast.error("Adding a key failed", TOAST_SETTINGS);
            }
        }
    }

    return (
        <DialogHESP
            title={"Add JWT key"}
            open={open}
            onClose={onClose}
            content={
                <>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <HESPFormLabel label="Key ID" />
                                    <TextField
                                        variant="outlined"
                                        style={{ background: "white" }}
                                        fullWidth
                                        value={keyId}
                                        onChange={(e) => setKeyId(e.target.value)}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <HESPFormLabel label="Shared (in case of HS256/HS512) or public (RS256/RS512) key to use" />
                                    <TextField
                                        variant="outlined"
                                        style={{ background: "white" }}
                                        fullWidth
                                        value={key}
                                        multiline
                                        rows={10}
                                        inputProps={{
                                            style: {
                                                padding: "8px 10px",
                                                background: "white",
                                                fontSize: "12px",
                                            },
                                        }}
                                        size="small"
                                        onChange={(e) => setKey(e.target.value)}
                                    />
                                </FormControl>
                                <FormControl>{key.trim().length === 0 && <>{`Key is mandatory`}</>}</FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <DialogFooterWithLoading
                            isLoading={loading}
                            onCancelClick={onClose}
                            defaultText={"Add"}
                            loadingText={"Adding..."}
                            onActionClick={() => addKey()}
                        />
                    </DialogActions>
                </>
            }
        />
    );
}
